import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { useSignalRContext } from "../Contexts/SignalRContext";
import { userAccountAjax } from "../../ajax/UserAccountAjax";
import { settingsAjax } from "../../ajax/SettingsAjax";
import { userInfoSuccess, roleConfigSuccess } from "../../state/reducers/authReducer";
import { ErrorResponse } from "../../DTOs/Common/ErrorResponse";

export default function UserInfoRefreshListener() {
  const dispatch = useDispatch();
  const { connection } = useSignalRContext();

  useEffect(() => {
    if (!connection) return;

    const handleUserInfoChanged = async () => {
      const [userDetails, roleConfig] = await Promise.all([
        userAccountAjax.getMyInfo(),
        settingsAjax.getRoleConfig(),
      ]);

      if (userDetails && !(userDetails instanceof ErrorResponse)) {
        dispatch(userInfoSuccess(userDetails));
      }
      if (!ErrorResponse.isErrorResponse(roleConfig)) {
        dispatch(roleConfigSuccess(roleConfig));
      }
    };

    connection.on("UserInfoChangedAsync", handleUserInfoChanged);

    return () => {
      connection.off("UserInfoChangedAsync", handleUserInfoChanged);
    };
  }, [connection, dispatch]);

  return null;
}
